

































import Vue from 'vue';
import store from '@/store';
import { WorkflowStep } from '@/store/getStarted';

export default Vue.extend({
  name: 'SetNameStep',

  data(): { userName: string } {
    return {
      userName: ''
    };
  },

  computed: {
    isNameReadOnly(): boolean {
      return !!store.state.getStarted.name;
    },

    userNameFromStore(): string {
      return store.state.getStarted.name || '';
    }
  },

  methods: {
    async submitName() {
      if (!this.userName) return;

      if (this.isNameReadOnly) {
        store.dispatch.getStarted.goToStep(
          WorkflowStep.CHOOSE_GO_TO_EXISTING_ORG_OR_CREATE
        );
        return;
      }

      await store.dispatch.getStarted.setUserName(this.userName);
    }
  },

  watch: {
    userNameFromStore: {
      immediate: true,
      handler(val) {
        if (val) {
          this.userName = val;
        }
      }
    }
  }
});
